var _defs, _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightgreen01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #9ba658;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m46.25,54.87s0,.03,0,.05c.15,3.07-5.39,4.52-8.31,8-1.77,2.1-3.3,5.81-2.12,12.86,1.55-.49,5.67-2.02,8.54-6.19,3.88-5.62,2.68-11.95,1.87-14.71Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m46.25,39.69s0,.03,0,.05c.15,3.07-5.39,4.52-8.31,8-1.77,2.1-3.3,5.81-2.12,12.86,1.55-.49,5.67-2.02,8.54-6.19,3.88-5.62,2.68-11.95,1.87-14.71Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m46.25,24.5s0,.03,0,.05c.15,3.07-5.39,4.52-8.31,8-1.77,2.1-3.3,5.81-2.12,12.85,1.55-.49,5.67-2.02,8.54-6.19,3.88-5.62,2.68-11.95,1.87-14.71Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m23.75,54.87s0,.03,0,.05c-.15,3.07,5.39,4.52,8.31,8,1.77,2.1,3.3,5.81,2.12,12.86-1.55-.49-5.67-2.02-8.54-6.19-3.88-5.62-2.69-11.95-1.87-14.71Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m23.75,39.69s0,.03,0,.05c-.15,3.07,5.39,4.52,8.31,8,1.77,2.1,3.3,5.81,2.12,12.86-1.55-.49-5.67-2.02-8.54-6.19-3.88-5.62-2.69-11.95-1.87-14.71Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m23.75,24.5s0,.03,0,.05c-.15,3.07,5.39,4.52,8.31,8,1.77,2.1,3.3,5.81,2.12,12.85-1.55-.49-5.67-2.02-8.54-6.19-3.88-5.62-2.69-11.95-1.87-14.71Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 34.5,
    y: 77.23,
    width: 1.68,
    height: 16.82
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m39.63,17.44c0,6.34-4.51,11.48-4.51,11.48,0,0-4.51-5.14-4.51-11.48s4.51-11.48,4.51-11.48c0,0,4.51,5.14,4.51,11.48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightgreen01);
export default __webpack_public_path__ + "static/media/lightgreen01.d1870079e34b473301d63a78b13cff43.svg";
export { ForwardRef as ReactComponent };